module.exports = __webpack_public_path__ + "img/skolkovo.2ce4b199.png";